import { useCallback } from 'react';
import type { VoidFunctionComponent } from 'react';

import { useDresser } from '../../../../contexts/DrawerContext';
import { BUTTON_SIZE, BUTTON_TYPE } from '../../../generic';
import Button from '../../../generic/Button';
import CustomRiskScoreDrawer from '../Drawer/CustomRiskScoreDrawer';
import { useIssueDetailsModals } from '../IssueDetailsModalsContext';
import type { VulnIssue } from '../../../../../shared/issuesV2';

const CUSTOM_RISK_SCORE_DRAWER_SLIDE_DURATION = 500;

type Props = {
  issue: VulnIssue;
};

const IssueDetailsActionButtonCustomRiskScore: VoidFunctionComponent<Props> = ({ issue }) => {
  const { isAnyModalOpen } = useIssueDetailsModals();
  const { pushDrawer, clearDrawers } = useDresser();
  const hasCustomRiskScore = !!issue.customRiskScore;

  const handleClick = useCallback(() => {
    pushDrawer(
      <CustomRiskScoreDrawer issue={issue} />,
      {
        slideDuration: CUSTOM_RISK_SCORE_DRAWER_SLIDE_DURATION,
        shouldSkipClickOutside: true,
        onClose: clearDrawers,
      },
    );
  }, [issue, pushDrawer, clearDrawers]);

  return (
    <Button
      type={BUTTON_TYPE.SECONDARY}
      size={BUTTON_SIZE.MEDIUM}
      onClick={handleClick}
      isDisabled={isAnyModalOpen}
      >
      {hasCustomRiskScore ? 'Edit Custom Risk Score' : 'Assign Custom Risk Score'}
    </Button>
  );
};

export default IssueDetailsActionButtonCustomRiskScore;
